

export enum ClientType {
  BOL = 'bol',
  MONTA = 'monta',
  IMPORT4YOU = 'import4you',
  PRODUCT_FLOW = 'product_flow',
  WOOCOMMERCE = 'woocommerce',
  SHOPIFY = 'shopify',
  AMAZON = 'amazon',
  CHANNELDOCK = 'channeldock',
}

export interface Connector {
  type: ClientType;
  image?: string;
  widget?: React.ComponentType;
  sort?: number;
}